<template>
    <div id="Customers">

        <smart-filter :drawer.sync="smartFilterDrawer" :filterProperties="filterProperties"
                      :filterValues="filterValues" @updateValues="updateFilterValues"/>
        <div class="listview-wrapper anim-box" :class="smartFilterDrawer?'sm-listview-active':''">
            <div class="btn-header">
                <v-row class="defaultgroup" :class="checkedItems.length||bulkSelectAll?'transform-hideview':''">
                    <v-btn icon class="filter-icon" @click="smartFilterDrawer=!smartFilterDrawer">
                        <v-badge :color="filterValues.length?'red':''" dot><v-icon class="green--text text--darken-2">mdi-filter-variant</v-icon></v-badge>
                    </v-btn>
                    <v-col class="pa-0" cols="3">
                    <v-text-field clearable label="Search by Customer name, mobile"  prepend-inner-icon="mdi-magnify"
                                  outlined hide-details @input="onSearch" v-model="search"/>
                </v-col>
                   <!-- <v-col cols="2" class="pa-0 ml-2">
                    <v-select outlined label="Select Label" v-model="selectedlabel"
                              multiple hide-details clearable :items="labels" item-text="name" item-value="id">
                        <template v-slot:selection="{ item, index }">
                            <v-chip small v-if="index === 0"><span>{{ item.name }}</span></v-chip>
                            <span v-if="index === 1" class="grey--text caption">(+{{ selectedlabel.length - 1 }} others)</span>
                        </template>
                    </v-select>
                    </v-col> -->
                   <!-- <v-col cols="2" class="pa-0 ml-2">
                    <v-autocomplete outlined :items="cityOptions" clearable hide-details label="City"
                                    v-model="selectedCity" item-text="name" item-value="id">
                        <template v-slot:item="{item}">
                            <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                            <v-list-item-action><v-icon class="yellow--text text--darken-3">mdi-{{item.icon}}</v-icon></v-list-item-action>
                        </template>
                    </v-autocomplete>
                </v-col>
                    <v-col cols="2" class="pa-0 ml-2">
                    <v-autocomplete outlined :items="salesExecutives" clearable hide-details label="Sales Executive"
                                    v-model="selectedSalesExecutive" item-text="name" item-value="id"/>
                    </v-col> -->
                    <v-spacer/>
                    <v-btn large class="primary text-capitalize elevation-0" title="Add Customer" @click="formDialog=true">Add Customer</v-btn>
                </v-row>
                <bulk-action-customer :filter="bulkFilter" @onCancelSelect="onChangeSelectAll($event)"
                                      class="checkedgroup" :class="checkedItems.length||bulkSelectAll?'transform-showview':''"/>
            </div>

            <v-data-table :headers="headers" :items="customers" :server-items-length="customersCount" fixed-header height="calc(100vh - 226px)"
                          :footer-props="{itemsPerPageOptions:rowsPerPageItems}" class="customer-table elevation-0"
                          :options.sync="options" @update:options="onUpdateOptions" @update:page="onUpdatePage">
                <template v-slot:no-data>No Customers Available</template>
                <template v-slot:no-results>No Customers Available</template>
                <template v-slot:header.checkbox="{}">
                    <v-checkbox v-model="bulkSelectAll" @click.stop="onChangeSelectAll(uncheckedItems.length>0||!bulkSelectAll)"
                                :indeterminate="!!(checkedItems.length||uncheckedItems.length)"/>
                </template>
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="(item,index) in items" :key="index" @click="rowClick(item)" :class="item.checked?'checked-row':''">
                        <td>
                            <v-checkbox v-model="item.checked" :class="item.checked?'check-icon checked':'check-icon'" @click.stop="onCheck(item)"/>
                        </td>
                        <td>
                            <v-menu  offset-y :close-on-content-click="false">
                            <template v-slot:activator="{ on:menu}">
                                <v-btn v-on="{...menu}" icon><v-icon :style="`color:${Constants.CustomerLabel[item.label]}`" :title="item.label">mdi-checkbox-blank</v-icon></v-btn>
                            </template>
                            <v-list dense>
                                <v-progress-linear :indeterminate="loading" absolute bottom></v-progress-linear>
                                <v-list-item-group color="primary">
                                    <v-list-item v-for="(value, key, index) in Constants.CustomerLabel" :key="index" @click="onSelectLabel(key, item)">
                                        <v-list-item-icon>
                                            <v-icon :style="`color:${value}`" >mdi-checkbox-blank</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title> {{ key.replace(/_/g, ' ') }}</v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-menu>
                        </td>
                        <td>
                        <v-btn icon>
                            <v-icon v-if="item.city === null" title="NA" class="yellow--text text--darken-3">mdi-star-half-full</v-icon>
                            <v-icon v-else-if="item.city.toLowerCase().trim() === 'surat'" title="Surat">mdi-star-outline</v-icon>
                            <v-icon v-else class="yellow--text text--darken-3" :title="item.city">mdi-star</v-icon>
                        </v-btn>
                        </td>
                        <td>
                            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.profileImage, type: 'IMAGE'}]))" title="View Image">
                                <v-img v-if="item.profileImage" :src="imgWpx(item.profileImage, 200)" alt="image" @error="item.profileImage = null">
                                    <template v-slot:placeholder>
                                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                    </template>
                                </v-img>
                                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                            </v-avatar>
                            <span class="c-name ellipsis" :title="item.name">{{ item.name }}<br>
                                <span :title="item.mobile" class="f-12 grey--text text--darken-1">{{item.mobile}}</span>
                            </span>
                        </td>
                            <td>
                                <span class="c-name ellipsis" :title="item.email">{{ item.email || '-' }}</span>
                            </td>

                        <td >{{ item.city || '-' }}</td>
                        <td>
                            <v-avatar tile :title="(item.SalesExecutive&&item.SalesExecutive.name)||'NA'" class="my-3 avatar" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.SalesExecutive.profileImage, type: 'IMAGE'}]))">
                                <v-img v-if="item.SalesExecutive&&item.SalesExecutive.profileImage" :src="imgWpx(item.SalesExecutive.profileImage, 200)" alt="image" @error="item.SalesExecutive.profileImage = null">
                                    <template v-slot:placeholder>
                                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                    </template>
                                </v-img>
                                <span v-else-if="item.SalesExecutive" size="50" color="blue-grey lighten-4">{{acronym_name(item.SalesExecutive.name)}}</span>
                                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                            </v-avatar>
                        </td>
                        <td>
                            <v-chip small label v-if="item.CustomerType" :color="item.CustomerType.colorCode">
                                <span>{{ item.CustomerType.type }}</span>
                            </v-chip>
                        </td>
                        <td title="Turning ON will lock field Customer-type in mobile">
                            <v-switch inset dense class="mt-0" color="success" v-model="item.disableType" @click.stop="" @change="updateTypeLock(item)"/>
                        </td>
                        <td title="Turning OFF will stop showing popup for GST Number in mobile">
                            <v-switch inset dense class="mt-0" color="success" v-model="item.askGst" @click.stop=""
                                      @change="onUpdateAskGst(item)" :loading="item.gstLoading"/>
                        </td>
                        <td><div style="white-space: nowrap">{{ dateTimeFormat(item.created_at) }}</div></td>
                        <td><div style="white-space: nowrap">{{ dateTimeFormat(item.updated_at) }}</div></td>
                        <td>
                            <v-menu nudge-bottom="25">
                                <template v-slot:activator="{ on:menu }">
                                    <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="onEditCustomer(item)"><v-list-item-title>Edit</v-list-item-title></v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </div>

<!--        <bulk-action-customer :dialog.sync="bulkActionDialog" :fieldId.sync="bulkFieldId" :filter="bulkFilter"/>-->
        <gallery id="gallery-o-detail" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"></gallery>
        <customer-form :formDialog="formDialog" @closeDialog="formDialog=false;customerId=null" :id="customerId"/>
        <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                            v-if="confirm.enable"/>
        <Snackbar :toaster="toaster"/>
    </div>
</template>

<script>
import moment from 'moment'
import {
    SUBSCRIBE_CUSTOMERS,
    SUBSCRIBE_CUSTOMERS_COUNT
} from '../../graphql/subscriptions/Customers'
import Constants from "../../Constants/Constants";
import CustomerForm from "./CustomerForm";
import {debounce} from "lodash";
import Snackbar from "../../components/Common/Snackbar";
import {generate_UPDATE_RECORD} from "../../graphql/mutations/Orders";
import {SUBSCRIBE_USERS_BY_TYPE} from "../../graphql/subscriptions/Users";
import {acronym_name, convertArrToJSON} from "../../util/helpers";
import Vue from 'vue';
import axios from 'axios';
import BulkActionCustomer from "./BulkActionCustomer";
import SmartFilter from "../../components/SmartFilter/SmartFilter";
import {GET_CUSTOMER_TYPES} from "../../graphql/queries/Customers";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};
let customerCityOptions = [{value:'EMPTY', text:'No City', icon:'star-half-full', class:'dark-yellow'},
                           {value:'SURAT', text:'Surat', icon:'star-outline', class:'dark-yellow'},
                           {value:'OUT_OF_SURAT', text:'Out Of Surat', icon:'star', class:'dark-yellow'}];
let labelOptions = Object.keys(Constants.CustomerLabel).map(i => ({value:i, text:i.replace(/_/g,' ')}));
export default {
    name: 'Customers',
    components: {ConfirmationDialog, SmartFilter, BulkActionCustomer, Snackbar, CustomerForm},
    apollo: {
        $subscribe: {
            customersCount:{
                query: SUBSCRIBE_CUSTOMERS_COUNT,
                variables () { return { filter: this.filter,
                  label: (this.filterValuesJson['label']?.value.length)? {_in: this.filterValuesJson['label'].value} : {},
                //   city: this.prepareCityFilterObject(this.filterValuesJson['city']?.value),
                  city: this.cityFilter(),
                  customerTypeId: (this.filterValuesJson['customerType']?.value) ?  {_eq: this.filterValuesJson['customerType'].value} : {},
                  salesExecutiveId: this.prepareSalesExecFilterObject(this.filterValuesJson['salesExecutive']?.value) }},
                result ({ data }) { this.customersCount = data.customersCount.aggregate.count },
            },
            Customers:{
                query: SUBSCRIBE_CUSTOMERS,
                variables () { return { filter: this.filter,
                  label: (this.filterValuesJson['label']?.value.length)? {_in: this.filterValuesJson['label'].value} : {},
                //   city: this.prepareCityFilterObject(this.filterValuesJson['city']?.value),
                  city: this.cityFilter(),
                  customerTypeId: (this.filterValuesJson['customerType']?.value) ?  {_eq: this.filterValuesJson['customerType'].value} : {},
                  salesExecutiveId: this.prepareSalesExecFilterObject(this.filterValuesJson['salesExecutive']?.value),
                  offset: this.options.offset, limit: this.options.limit}},
                result ({ data }) { this.customers = data.Customers; this.afterFetchingCustomers() },
            },
            Users: {
                query: SUBSCRIBE_USERS_BY_TYPE,
                variables(){ return{ roleId: Constants.UserRoles.SalesExecutive } },
                result ({ data}) {
                    this.salesExecutives = [{id:'EMPTY', name:'No Sales Executive'}, ...data.Users];
                    let index = this.filterProperties.findIndex(p => p.id === 'salesExecutive')
                    this.filterProperties[index].options = this.salesExecutives.map(s => ({text:s.name, value:s.id, image:s.profileImage}))
                }
            },
        },
        customerTypes: {
            query: GET_CUSTOMER_TYPES,
            result({data}) {
                let index = this.filterProperties.findIndex(p => p.id === 'customerType')
                this.filterProperties[index].options = data.customerTypes.map(t => ({text:t.type, value:t.id, icon:'checkbox-blank', color:t.colorCode}))
            }
        }
    },
    data () {
        return {
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            moment: moment,
            headers: [
                {text: '', value: 'checkbox', width: 10, sortable:false},
                { text: 'LABEL', value: 'label', width:84 }, { text: '', value: 'starRepresentCity' },
                { text: 'NAME', value: 'name' , width:260 }, /*{ text: 'MOBILE', value: 'mobile' },*/
                { text: 'EMAIL', value: 'email', width:100 },/* { text: 'TYPE', value: 'type' },*/
                /*{ text: 'STATUS', value: 'status' },*/ { text: 'CITY', value: 'city' },{ text: 'SE', value: 'salesExecutive' },
                {text: 'CUSTOMER TYPE', value: 'customerType'}, {text:'LOCK FIELD TYPE', value:'disableType', sortable:false, width:95},
                {text:'ASK GST', value:'askGst', sortable:false, width:95}, { text: 'CREATED ON', value: 'created_at'},
                { text: 'UPDATED ON', value: 'updated_at'}, {text:'ACTION', value:'actions', sortable:false}
            ],
            customers: [],
            customersCount: 0,
            options: options,
            isStarCityFilter: false,
            isCityFilter: false,
            offset: 0, limit: 25, itemsPerPage: 25, rowsPerPageItems: [25, 50, 100, -1],
            search: '',
            filter: '%%',
            galleryImages: [],
            galleryIndex: null,
            formDialog: false,
            customerId: null,
           /* labels: Object.keys(Constants.CustomerLabel).map(i => ({id:i, name:i.replace(/_/g,' ')})), */
            selectedlabel: [],
            menu: false,
            loading: false,
            toaster: { enable: false, color: 'green', message: '' },
            /* salesExecutives: [],
            selectedSalesExecutive: null, */
            acronym_name,
            /* cityOptions: [{id:'EMPTY', name:'No City', icon:'star-half-full'},{id:'SURAT', name:'Surat', icon:'star-outline'},
                {id:'OUT_OF_SURAT', name:'Out Of Surat', icon:'star'}],
            selectedCity: null, */
            checkedItems: [],
            uncheckedItems: [],
            bulkSelectAll: false,
            smartFilterDrawer: false,
            filterProperties: [
                {id:'starCity', type:'select', label:'Star City', options:customerCityOptions},
                {id:'city', type:'select', label:'City', options:[]},
                {id:'salesExecutive', type:'select', label:'Sales Executive', options:[]},
                {id:'customerType', type:'select', label:'Customer Type', options:[]},
                {id:'label', type:'multiSelect', label:'Label', options:labelOptions}
            ],
            filterValues: [],
            confirm: {enable: false}
        }
    },
    computed:{
      bulkFilter(){
          let variables = JSON.parse(this.$apollo.subscriptions.customersCount.previousVariablesJson);
          return  {ids: this.bulkSelectAll?'ALL':this.checkedItems, uncheckedIds:this.uncheckedItems, allCount:this.customersCount, variables};
      },
      filterValuesJson: function(){
          return convertArrToJSON(this.filterValues, 'id')
      },
    },
    async created() {
        const payload = { "country" : "India" }
        const response = await axios({ method: 'POST', url: "https://countriesnow.space/api/v0.1/countries/cities", data: payload });
        const data = response.data.data;

        const transformedArray = data.map(item => ({
        value: item,
        text: item,
        class: 'dark-yellow'
        }));
        
        let index = this.filterProperties.findIndex(p => p.id === 'city')
        this.filterProperties[index].options = transformedArray
    },
    methods: {
        updateFilterValues(filterValues){
            let filterValuesData = filterValues
            this.filterValues
            const isStarCityFilter = filterValues.some(f => f.id === 'starCity'); 
            const isCityFilter = filterValues.some(f => f.id === 'city'); 
            this.isStarCityFilter = isStarCityFilter ? true : false;
            this.isCityFilter = isCityFilter ? true : false;

            if (isStarCityFilter && isCityFilter) {
                filterValuesData = filterValues.filter(f => f.id !== 'starCity');
                this.isStarCityFilter = false;
            }
            this.filterValues = filterValuesData
        },
        cityFilter() {
            if (this.isCityFilter) {
                return this.prepareCityFilterObject(this.filterValuesJson['city']?.value);
            } else {
                return this.prepareCityFilterObjectData(this.filterValuesJson['starCity']?.value);
            }
        },
        afterFetchingCustomers(){
            if(this.bulkSelectAll) this.customers.forEach(c => this.uncheckedItems.includes(c.id) || Vue.set(c, 'checked', true));
            else if(this.checkedItems.length) this.customers.forEach(c => this.checkedItems.includes(c.id) && Vue.set(c, 'checked', true));
        },
        onCheck(row){
            Vue.set(row, 'checked', !row.checked);
            if(row.checked && this.bulkSelectAll) this.uncheckedItems.splice(this.uncheckedItems.indexOf(row.id), 1);
            else if(!row.checked && this.bulkSelectAll) this.uncheckedItems.push(row.id);
            else if(row.checked  && !this.bulkSelectAll) this.checkedItems.push(row.id);
            else if(!row.checked && !this.bulkSelectAll)this.checkedItems.splice(this.checkedItems.indexOf(row.id), 1);
            if(this.uncheckedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(false)
            else if(this.checkedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(true)
            //this.bulkSelectAll = false                                 /* Reset value */
        },
        onChangeSelectAll(value){
          this.bulkSelectAll = value;
          this.customers.forEach(c => Vue.set(c, 'checked', value));
          /*if(value) this.checkedItems = this.customers.map(c => c.id)*/
          this.checkedItems = [];                                         /* Reset value */
          this.uncheckedItems = [];                                       /* Reset value */
        },
        prepareCityFilterObjectData(selection){
            if(selection === 'EMPTY') return {_is_null: true};
            if(selection === 'SURAT') return {_ilike: '%surat%'};
            if(selection === 'OUT_OF_SURAT') return {_nilike: '%surat%'};
            if(selection) return {_ilike: `%${selection}%`}
            return {}
        },
        prepareCityFilterObject(selection){
            if(selection) return {_ilike: `%${selection}%`}
            return {}
        },
        prepareSalesExecFilterObject(selection) {
            if (selection === 'EMPTY') return {_is_null: true};
            if (selection) return {_eq: selection};
            return {}
        },
        rowClick(row){
            this.$router.push({ path: '/customer/'+row.id})
        },
        onEditCustomer(item){
            this.customerId = item.id
            this.formDialog = true
        },
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.customersCount          //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
        onUpdatePage(){
            this.$vuetify.goTo('.customer-table tbody tr', {offset:50, container: '.v-data-table__wrapper'});  /* scroll to top */
        },
        onSelectLabel(label, row){
            if(label === row.label) return;
            this.loading = true
            let obj = { label: label, updated_at:moment().format(), updatedBy:this.user.id }
            this.updateRecord(row.id, obj, 'Customers', () => {
                this.loading = false
                this.menu = false
                this.toaster = {...this.toaster, enable:true, message: `Customer Label Updated Successfully`}
            })
        },
        onUpdateAskGst(row){
            this.confirm = {enable:true, message:`Are you sure you ${row.askGst?'':`don't `}want to show popup to this customer for GST number?`,
                method: () => this.updateAskGst(row), closeMethod:() => this.revertAskGst(row)};
        },
        updateAskGst(row){
            row.gstLoading = true;
            this.confirm = {enable: false};
            let obj = { askGst: row.askGst, updatedBy:this.user.id };
            this.updateRecord(row.id, obj, 'Customers', () => {
                this.toaster = {...this.toaster, enable:true, message: `Customer Updated Successfully`};
                row.gstLoading = false;
            })
        },
        revertAskGst(row){
            row.askGst = !row.askGst;
            this.confirm = {enable: false};
        },
        updateTypeLock(row){                             /* For locking 'customerType' field in Mobile */
            let obj = { disableType: row.disableType, updatedBy:this.user.id };
            this.updateRecord(row.id, obj, 'Customers', () => {
                this.toaster = {...this.toaster, enable:true, message: `Customer Updated Successfully`};
            })
        },
        async updateRecord(id, obj, table, callback){
            let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_RECORD(table),
                variables: { id: id, obj: obj}
            })
            if(response.data) callback()
        },
        onSearch: debounce(function(val){
            this.filter = val?('%'+val+'%'):'%%'
            this.options = options          //on search, reset page options
        }, 500),
        dateTimeFormat (timestamp) {
            return timestamp ? moment(timestamp).format('DD MMM, YYYY hh:mm A') : '-'
        },
        openGallery(arr){
            this.galleryImages = arr.map(m => {return {
                href: this.imgWpx(m.path, 900),
                type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
            }})
            this.galleryIndex = 0
        }
    }
}
</script>

<style scoped>
.customer-table{
    margin: -20px 0 0 0;
}
.customer-table:hover{
    cursor: pointer;
}
.avatar{
   cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.c-name{
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    max-width: 140px;
}
.f-12{
    font-size: 12px;
}
/deep/ .customer-table tbody tr .check-icon .v-icon{
  opacity: 0.2;
}
/deep/ .customer-table tbody tr .checked .v-icon{
  opacity: unset;
}
/deep/ .customer-table tbody tr:hover .check-icon .v-icon{
  opacity: unset;
}
/deep/ .customer-table tbody tr.checked-row{
  background: #eff2f5;
}
/* ---- Bulk Action Styles ---- */
.btn-header{
    /*height: 86px;*/
    overflow: hidden;
    padding: 15px 20px 0px 20px;
}
.btn-header .defaultgroup{
    transform: translateY(0);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.btn-header .checkedgroup{
    transform: translateY(110%);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.transform-hideview{                   /* To hide defaultgroup */
    transform: translateY(-190%) !important;
}
.transform-showview{                   /* To show checkedgroup */
    transform: translateY(-100%) !important;
}
/* ---------x---------x-------- */
/* ---- Smart Filter Styles ---- */
.filter-icon{
    background: #e3f1eb;
    margin: 10px 16px 0 0;
}
.more-options-icon{
    background: #e3f1eb;
    margin: 4px 0px 0 0;
}
.listview-wrapper{
    flex-grow: 1;
    transition: all 0.2s ease-in 0s;
    max-width: 100%;
    width: 100%;
    padding: 12px 12px 0 12px;
}
@keyframes slide-anim {
    0% { opacity: 0; transform: translateY(-20px); }
    100% { opacity: 1; transform: translateY(0px); }
}
.anim-box{
    animation: 0.2s ease 0s 1 normal none running slide-anim;
}
.sm-listview-active {
    margin-left: 330px;
    width: 78%;
}
/* ---------x---------x-------- */
</style>
